import { Auth } from "aws-amplify";
import axios from "axios";
import { COGNITO } from "../generated-aws";
import { ExportRecord } from "../models/export-record";

const { API_HOST } = COGNITO;

export type ExportType = "notifications" | "results" | "activity";

type ExportServiceRequests = {
  isHttpError: (err: any) => boolean;
  generateExport: (exportType: ExportType) => Promise<ExportRecord>;
  getExportList: () => Promise<ExportRecord[]>;
  getExportDownload: (exportType: ExportType) => Promise<string>;
};

const exportServiceRequests: ExportServiceRequests = {
  isHttpError: (err: any) => {
    return axios.isAxiosError(err);
  },
  generateExport: async (exportType: ExportType) => {
    const session = await Auth.currentSession();
    const requestBody = { ExportType: exportType };
    const res = await axios.post(`${API_HOST}/export`, requestBody, {
      headers: {
        Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
        "Content-Type": "application/json",
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    throw new Error(`Unable to generate export for: ${exportType}`);
  },
  getExportList: async () => {
    const session = await Auth.currentSession();
    const res = await axios.get(`${API_HOST}/export/list`, {
      headers: {
        Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
        "Content-Type": "application/json",
      },
    });

    if (res.status === 200) {
      return res.data.exportRecords;
    }

    throw new Error(`Unable to fetch`);
  },
  getExportDownload: async (exportType: ExportType) => {
    const session = await Auth.currentSession();
    const res = await axios.get(`${API_HOST}/export/${exportType}/download`, {
      headers: {
        Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
        "Content-Type": "application/json",
      },
    });

    if (res.status === 200) {
      return res.data.downloadUrl;
    }

    throw new Error(`Unable to fetch`);
  },
};

export default exportServiceRequests;
